<div class="processing-modal-overlay" *ngIf="isProcessing">
  <div class="processing-modal-container">
    <div class="progress-container">
      <svg class="progress-ring" width="80" height="80">
        <circle
          class="progress-ring-circle"
          stroke="#e0e0e0"
          stroke-width="4"
          fill="transparent"
          r="36"
          cx="40"
          cy="40"/>
        <circle
          class="progress-ring-circle progress-ring-fill"
          stroke="#007bff"
          stroke-width="4"
          fill="transparent"
          r="36"
          cx="40"
          cy="40"
          [style.stroke-dasharray]="circumference"
          [style.stroke-dashoffset]="circumference - (progress / 100) * circumference"/>
      </svg>
      <div class="progress-content" *ngIf="!isCompleted">
        <!-- <div class="progress-text">{{ progress | number:'1.0-0' }}%</div> -->
        <div class="loading-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
      <div class="completion-checkmark" *ngIf="isCompleted">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="#28a745"/>
        </svg>
      </div>
    </div>
    <div class="processing-message">
      {{ processingMessage }}
    </div>
  </div>
</div>
